import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  Button,
  Descriptions,
  Typography,
  Skeleton
} from "antd";

import { get, generateUrl } from '../../../api/modules/resources';

import INTERNAL_LINKS from "../../../enum/InternalLinks";

const { Title } = Typography;

const FileFormPage = ({ match }) => {
  const [data, setData] = useState({});
  const [dataLoading, setDataLoading] = useState(true);

  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const load = async () => {
    await Promise.all([
      getData(),
    ]);
  }
  const getData = async () => {
    setDataLoading(true);
    try {
      const response = await get(match.params.id);
      setData(response.data);
    } catch (err) {
      console.log(err);
    }
    setDataLoading(false);
  };

  const downloadFile = async () => {
    const response = await generateUrl(match.params.id);
    window.open(response.data.result);
  };

  return (<>
    <Title level={3}>File Details / Detalle de Archivo</Title>
    <Skeleton loading={dataLoading} >
      {data &&
        <Descriptions bordered column={1} layout="vertical">
          <Descriptions.Item label="Country / País">{data.country_name}</Descriptions.Item>
          <Descriptions.Item label="City / Ciudad">{data.city_name}</Descriptions.Item>
          <Descriptions.Item label="Theme / Temática">{data.topic}</Descriptions.Item>
          <Descriptions.Item label="Source / Fuente">{data.source}</Descriptions.Item>
          <Descriptions.Item label="Year / Año">{data.year}</Descriptions.Item>
          <Descriptions.Item label="Abstract">{data.abstract}</Descriptions.Item>
          <Descriptions.Item label="File / Archivo">
            <Button onClick={downloadFile} type="primary">Download / Descargar</Button>
          </Descriptions.Item>
        </Descriptions>
      }
    </Skeleton>
    <br></br>
    <br></br>
    <Button type="primary"><Link to={INTERNAL_LINKS.FILES}>Back / Volver</Link></Button>
  </>);
};

export default FileFormPage;